import React, { useState } from 'react';
//import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox, IconButton, Badge, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { InfoOutlined } from '@material-ui/icons';
import { Datatable } from '../../components';
import { AnnulJobModal } from './AnnulJobModal';
import { SendSMSActions } from './components/SendSMSActions';
import { formatEasternDate } from '../../utils/DateUtil';

export const TradesNeeded = ({
  data,
  sendSMS,
  sendingSms,
  sendCodeExchangeSMS,
  updateStatus,
  tradesLoading,
  toggleJobModal,
}) => {
  const [selected, setSelected] = useState([]);
  const [jobToAnnul, setJobToAnnul] = useState('');
  const [annulModalOpen, setAnnulModalOpen] = useState(false);

  const handleAnnulModalClose = () => {
    setAnnulModalOpen(false);
    setJobToAnnul('');
  };

  const handleAnnul = () => {
    updateStatus(jobToAnnul, 'annulled');
  };

  const PaddedBadge = withStyles((theme) => ({
    root: {
      marginLeft: theme.spacing(2),
    },
  }))(Badge);

  const tableConfig = [
    {
      heading: 'Inspect',
      key: 'id',
      headingStyles: { width: '25px' },
      formatter: (val) => (
        <IconButton
          aria-label="inspect"
          onClick={() => {
            toggleJobModal(val);
          }}
        >
          <InfoOutlined />
        </IconButton>
      ),
    },
    {
      sortable: true,
      heading: 'Participant Name',
      key: 'participantName',
      formatter: (val, row) =>
        row?.expirationCount > 0 ? (
          <span>
            {val}
            <Tooltip title="Recycle Count">
              <PaddedBadge badgeContent={row.expirationCount} color="error" />
            </Tooltip>
          </span>
        ) : (
          val
        ),
    },
    {
      sortable: true,
      heading: 'Queue Date',
      key: 'created',      
      formatter: formatEasternDate,
    },
    {
      heading: 'Product',
      sortable: true,
      key: 'product',
      formatter: (val) => val,
    },
    { heading: 'Type', sortable: true, key: 'type', formatter: (val) => val },
    {
      sortable: true,
      heading: 'Advisor',
      key: 'advisorName',
    },
    {
      heading: 'Send Trade',
      key: 'id',
      formatter: (val) => (
        <Checkbox
          color="primary"
          checked={selected.includes(val)}
          inputProps={{ 'aria-label': 'primary checkbox' }}
          onClick={() => {
            setSelected((prev) =>
              prev?.includes?.(val)
                ? [...prev.filter((i) => i !== val)]
                : [...prev, val]
            );
          }}
        />
      ),
    },
    {
      heading: '',
      key: 'id',
      headingStyles: { width: '25px' },
      formatter: (val) => (
        <IconButton
          aria-label="delete"
          onClick={() => {
            setJobToAnnul(val);
            setAnnulModalOpen(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <AnnulJobModal
        open={annulModalOpen}
        onSubmit={handleAnnul}
        handleClose={handleAnnulModalClose}
      />
      <Datatable
        loading={tradesLoading}
        tableHeading="Trades Needed"
        hasSearch={true}
        defaultSortColumn="created"
        defaultSortDirection="desc"
        data={data}
        tableConfig={tableConfig}
        paginationLeft={true}
        footerContent={
          <SendSMSActions
            loading={sendingSms}
            disabled={selected.length === 0}
            sendSMS={() => {
              sendSMS(selected);
              setSelected([]);
            }}
            sendCodeExchangeSMS={() => {
              sendCodeExchangeSMS(selected);
              setSelected([]);
            }}
          />
        }
      />
    </>
  );
};
